import { InjectionToken } from '@angular/core';
import { IPlanService } from './plan-service.interface';

export const PLAN_SERVICE = new InjectionToken<IPlanService>('PLAN_SERVICE');
